__webpack_require__.p = "/french_AI_bot/";